export default "__VITE_ASSET__BD$YhhJX__"